import { api } from './configs/axiosConfig'
import { defineCancelApiObject } from './configs/axiosUtils'

export const formsApi = {

  getFormList: async function (cancel = false) {
    const response = await api.request({
      url: `${process.env.REACT_APP_GIANT_API_URL}/SistemaTracking/all`,
      method: "GET",
      withCredentials: true,
      signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  }

}

const cancelApiObject = defineCancelApiObject(formsApi)
